class DeliveryManifestAllController {
    /*@ngInject*/
    constructor(Auth, $state, $translate, ShipmentService) {
        this.$translate = $translate;
        this.$state = $state;
        this.Auth = Auth;
        this.ShipmentService = ShipmentService;
        this.printData = [];
        this.printData = undefined;
        this.loading = false;
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.printData = window.opener.w.printData;

            this.loading = true;
            this.ShipmentService.deliveryManifestAll(this.printData.routeId, this.printData.routeDate)
                .then((res) => {
                    this.printData = res.results;
                    setTimeout(() => {
                        window.print();
                    }, 1500)
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                })
        }
    }
}

export default DeliveryManifestAllController;


// WEBPACK FOOTER //
// ./client/app/components/route_control/delivery_manifest_all/delivery_manifest_all.controller.js